// Module
var code = `<div class="jumbotron small"> <h2>Forbidden</h2> <p>You are not authorized to access this application.</p> <a class="btn btn-primary" ng-show="forbiddenController.customer.url" ng-href="{{ forbiddenController.customer.url }}">Back to portal</a> </div> `;
// Exports
module.exports = code;